import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import {AutotextService} from '../autotext.service';
import { LoginService } from '../login.service';
import { MatDialog } from '@angular/material/dialog';
import { GuideComponent } from '../guide/guide.component';

@Component({
    selector: 'app-autotext',
    templateUrl: './autotext.component.html',
    styleUrls: ['./autotext.component.scss'],
    standalone: false
})
export class AutotextComponent implements OnInit, OnDestroy {

  rowData;
  Text:string;
  FilterBy;
  sub = new Subscription();

   constructor(
    public atS: AutotextService,
    private fb: FormBuilder,
    public ls: LoginService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.rowData = null;
    this.atS.filter=1;
    this.reload(1);
    this.Text = this.htmlToText(this.atS.currentText.value || '');
    this.resetFilter();

  }
  resetFilter(){
    this.FilterBy = this.fb.group({
      type:[1]
    })
    this.sub = this.FilterBy.get('type').valueChanges.subscribe((data) =>{
      this.atS.filter = data;
      if(data)
        this.reload(data)
      else
        this.reload()
    })
  }


  reload(filter = null){
    if(this.FilterBy?.get('type').value == 1 || !this.ls.isCardio)
      filter = 1;
    this.atS.getTexts(this.atS.currentFieldID.toString(),filter).subscribe((data)=>{
      this.rowData = data;
    },
    (error)=>{
      console.log(error);
    });
  }

  save(){
    let text = this.Text;
    if (this.atS.isHtml && text) {
      text = text.replace(/\n/g, '<br>');
    }
    this.atS.currentText.setValue(text);
    this.atS.Display=false;
  }

  addText(toadd:string){
    const clean = this.htmlToText(toadd);
    if(this.Text && this.Text != "")
      this.Text += '\n' + clean;
    else this.Text = clean;
  }

  private htmlToText(html: string): string {
    html = html.replace(/<\/p>\s*<p[^>]*>/gi, '\n');
    html = html.replace(/<\/div>\s*<div[^>]*>/gi, '\n');
    html = html.replace(/<br\s*\/?>/gi, '\n');
    html = html.replace(/<\/?(?:p|div)[^>]*>/gi, '');
    html = html.replace(/<[^>]+>/g, '');
    html = html.replace(/&nbsp;/gi, ' ');
    html = html.replace(/&amp;/gi, '&');
    html = html.replace(/&lt;/gi, '<');
    html = html.replace(/&gt;/gi, '>');
    html = html.replace(/&#(\d+);/g, (_m, code) => String.fromCharCode(+code));
    html = html.replace(/&#x([0-9a-f]+);/gi, (_m, code) => String.fromCharCode(parseInt(code, 16)));
    return html.trim();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

  openDialog() {
    const rawPath = "/assets/pdf/auto_text_guide.pdf#toolbar=0";

    const dialogRef = this.dialog.open(GuideComponent, {
      width: "40vw",
      height: "90vh",
      data: { pdfPath: rawPath },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result:`, result);
    });
  }

}
